module.exports = __webpack_public_path__ + "media/images/user-shape-8e53b98bcb0ceb4f56edbeff75a3a786.jpeg";